import React from 'react';

interface PlusIconProps {
  onClick?: () => void;
  title?: string;
  className?: string;
}

export const PlusIcon: React.FC<PlusIconProps> = ({ onClick, title, className = '' }) => {
  return (
    <button
      className={`plus-icon ${className}`}
      onClick={onClick}
      title={title}
      type="button"
    >
      <span className="plus-icon-symbol">+</span>
    </button>
  );
};
